import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { AnalyticsPeriod } from "@/utils/analyticsPeriod";
import { useAnalyticsConversao } from "@/hooks/useAnalyticsConversao";
import PeriodFilter from "./PeriodFilter";
import MetricsCards from "./MetricsCards";
import ChartsBlock from "./ChartsBlock";
import FunisCards from "./FunisCards";
import AnonimoLogadoCard from "./AnonimoLogadoCard";
import AlertasConversao from "./AlertasConversao";
import TopListas from "./TopListas";
import EventosRecentes from "./EventosRecentes";

const AnalyticsConversao: React.FC = () => {
  const [period, setPeriod] = useState<AnalyticsPeriod>("24h");
  const { data: events, isLoading, error } = useAnalyticsConversao(period);

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0">
          <CardTitle>Analytics de Conversão</CardTitle>
          <PeriodFilter value={period} onChange={setPeriod} />
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Dados ao vivo de <code>analytics_events</code>. Cache de 60s. Limite de 5000 eventos por consulta.
        </CardContent>
      </Card>

      {isLoading && (
        <div className="flex items-center justify-center py-12 text-muted-foreground">
          <Loader2 className="w-5 h-5 mr-2 animate-spin" /> Carregando eventos...
        </div>
      )}

      {error && (
        <Card>
          <CardContent className="p-4 text-sm text-red-600">
            Erro ao carregar eventos: {(error as Error).message}
          </CardContent>
        </Card>
      )}

      {events && !isLoading && (
        <>
          <MetricsCards events={events} />
          <ChartsBlock events={events} period={period} />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <AnonimoLogadoCard events={events} />
            <AlertasConversao events={events} />
          </div>
          <FunisCards events={events} />
          <TopListas events={events} />
          <EventosRecentes events={events} />
        </>
      )}
    </div>
  );
};

export default AnalyticsConversao;
